<template>
  <div class="mail-monitor h-full bg-[#fff]">
    <div class="page-head">
      <div>
        <div class="page-title">账户异常提醒</div>
        <div class="page-desc">数据来源：已授权 Gmail 的 Google Ads 官方通知。展示范围 = 你在广告管理里可见的账户，以及你自己授权邮箱里收到的通知。</div>
      </div>
      <div>
        <el-button
          size="medium"
          @click="refreshPage"
        >
          刷新
        </el-button>
        <el-button
          size="medium"
          @click="authMailbox"
        >
          授权邮箱
        </el-button>
      </div>
    </div>

    <div class="tabs">
      <div
        class="tab"
        :class="{ active: tab === 'account' }"
        @click="switchTab('account')"
      >
        账户异常
        <span
          v-if="accountTotal"
          class="badge"
        >{{ accountTotal }}</span>
      </div>
      <div
        class="tab"
        :class="{ active: tab === 'mail' }"
        @click="switchTab('mail')"
      >
        邮件流水
      </div>
      <div
        class="tab"
        :class="{ active: tab === 'mailbox' }"
        @click="switchTab('mailbox')"
      >
        监听邮箱
      </div>
      <div
        class="tab"
        :class="{ active: tab === 'orphan' }"
        @click="switchTab('orphan')"
      >
        未挂账户
        <span
          v-if="orphanTotal"
          class="badge gray"
        >{{ orphanTotal }}</span>
      </div>
    </div>

    <ad-table-page
      v-show="tab === 'account'"
      :showForm="true"
      v-model="formData"
      :tableConfig="tableConfig"
      :btnList="[]"
      :filedList="filedList"
      class="h-full"
      :formPrams="{
        inline: true,
        size: 'medium',
      }"
      @reset="formData = { status: 'OPEN' }"
    >
      <template #account="{ row }">
        <div>
          <p
            class="text-[#207ae6] cursor-pointer"
            @click="viewDetail(row)"
          >
            {{ row.accountName || '--' }}
          </p>
          <p class="text-[12px] text-[#999] font-mono">{{ row.customerIdDisplay || row.customerId }}</p>
        </div>
      </template>
      <template #eventType="{ row }">
        <el-tag
          size="mini"
          :type="eventTagType(row.eventType)"
        >
          {{ row.eventTypeDesc || eventTypeText(row.eventType) }}
        </el-tag>
      </template>
      <template #reason="{ row }">
        <div>
          <p>{{ row.reason || '--' }}</p>
          <p
            v-if="row.policyTopic"
            class="text-[12px] text-[#999]"
          >
            {{ row.policyTopic }}
          </p>
        </div>
      </template>
    </ad-table-page>

    <div
      v-show="tab === 'mail'"
      class="panel"
    >
      <div class="note">同一封信涉及多个账户会拆成多行；两只邮箱收到同一封信是两条证据，但账户异常只算一次。</div>
      <el-table
        :data="mailRows"
        size="medium"
      >
        <el-table-column
          label="广告账户"
          min-width="180"
        >
          <template slot-scope="{ row }">
            <div>{{ row.accountName || '--' }}</div>
            <div class="text-[12px] text-[#999] font-mono">{{ row.customerIdDisplay || row.customerId }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="事件类型"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="eventTagType(row.eventType)"
            >
              {{ row.eventTypeDesc || eventTypeText(row.eventType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="subject"
          label="邮件主题"
          min-width="240"
        />
        <el-table-column
          prop="fromAddress"
          label="发件人"
          width="220"
        />
        <el-table-column
          prop="googleEmail"
          label="收件邮箱"
          width="200"
        />
        <el-table-column
          label="收件时间"
          width="170"
        >
          <template slot-scope="{ row }">{{ formatTime(row.receivedTime) }}</template>
        </el-table-column>
        <template slot="empty">暂无邮件流水</template>
      </el-table>
    </div>

    <div
      v-show="tab === 'mailbox'"
      class="panel"
    >
      <div class="note">仅采集配置用。优化师不需要授权自己的邮箱，也能看到自己账户的异常。</div>
      <el-table
        :data="mailboxWatch"
        size="medium"
      >
        <el-table-column
          prop="email"
          label="Gmail 邮箱"
          min-width="220"
        />
        <el-table-column
          prop="creatorName"
          label="录入人"
          width="120"
        >
          <template slot-scope="{ row }">{{ row.creatorName || '--' }}</template>
        </el-table-column>
        <el-table-column
          label="授权状态"
          width="120"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="row.authStatus === 'VALID' ? 'success' : 'info'"
            >
              {{ authStatusText(row.authStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="监听状态"
          width="120"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="row.watching ? 'success' : 'info'"
            >
              {{ watchStatusText(row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="最后收信"
          width="170"
        >
          <template slot-scope="{ row }">{{ row.lastPushTime || '--' }}</template>
        </el-table-column>
        <el-table-column
          label="最近错误"
          min-width="220"
        >
          <template slot-scope="{ row }">{{ row.lastSyncError || '--' }}</template>
        </el-table-column>
        <template slot="empty">尚未授权邮箱</template>
      </el-table>
    </div>

    <div
      v-show="tab === 'orphan'"
      class="panel"
    >
      <div class="note">命中解析规则、但正文里找不到客户 ID 的邮件（多为支持工单）。只有该邮箱录入人可见，不进优化师列表。</div>
      <el-table
        :data="orphanRows"
        size="medium"
      >
        <el-table-column
          label="事件类型"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="eventTagType(row.eventType)"
            >
              {{ row.eventTypeDesc || eventTypeText(row.eventType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="subject"
          label="邮件主题"
          min-width="240"
        />
        <el-table-column
          prop="fromAddress"
          label="发件人"
          width="220"
        />
        <el-table-column
          prop="googleEmail"
          label="收件邮箱"
          width="200"
        />
        <el-table-column
          label="收件时间"
          width="170"
        >
          <template slot-scope="{ row }">{{ formatTime(row.receivedTime) }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="90"
        >
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="viewOrphan(row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">暂无未挂账户邮件</template>
      </el-table>
    </div>

    <el-drawer
      :title="drawerTitle"
      size="760px"
      :visible.sync="detailShow"
      append-to-body
    >
      <div
        class="px-4 pb-4"
        v-loading="detailLoading"
      >
        <el-descriptions
          :column="1"
          border
          size="medium"
        >
          <el-descriptions-item label="广告账户">{{ detail.accountName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="客户 ID">{{ detail.customerIdDisplay || detail.customerId }}</el-descriptions-item>
        </el-descriptions>

        <div class="mt-5 text-[14px] font-semibold text-[#303133]">事件时间线</div>
        <div
          v-if="!(detail.timeline && detail.timeline.length)"
          class="mt-4 text-center text-[#909399] py-8"
        >
          暂无事件
        </div>
        <div
          v-else
          class="timeline mt-3"
        >
          <div
            v-for="item in detail.timeline"
            :key="item.eventId"
            class="tl-item"
            :class="{ red: item.restrict && !item.resolvedAt, green: !!item.resolvedAt }"
          >
            <div class="text-[12px] text-[#909399]">{{ formatTime(item.occurredAt) }}</div>
            <div class="mt-1 flex items-center gap-2 flex-wrap">
              <el-tag
                size="mini"
                :type="eventTagType(item.eventType)"
              >
                {{ item.eventTypeDesc || eventTypeText(item.eventType) }}
              </el-tag>
              <el-tag
                v-if="item.resolvedAt"
                size="mini"
                type="success"
              >
                已恢复
              </el-tag>
              <span
                v-if="item.deadlineAt"
                class="text-[12px] text-[#e6a23c]"
              >
                截止 {{ formatTime(item.deadlineAt) }}
              </span>
            </div>
            <div class="mt-1 text-[#606266] leading-6">{{ item.reason || '--' }}</div>
            <div
              v-if="item.policyTopic"
              class="text-[12px] text-[#909399]"
            >
              政策：{{ item.policyTopic }}
            </div>

            <div
              v-for="mail in item.evidence || []"
              :key="mail.mailId"
              class="evi mt-2"
            >
              <div class="evi-head">
                <span>{{ mail.googleEmail || '--' }}</span>
                <span class="text-[#909399]">{{ formatTime(mail.receivedTime) }}</span>
              </div>
              <div class="evi-body">
                <div class="font-medium">{{ mail.subject }}</div>
                <div class="text-[12px] text-[#909399] mt-1">{{ mail.fromAddress }}</div>
                <div
                  v-if="mail.matchedText"
                  class="mt-2 text-[12px] text-[#606266] bg-[#f5f7fa] px-2 py-1 rounded"
                >
                  命中：{{ mail.matchedText }}
                </div>
                <mail-body
                  class="mt-2"
                  :content="mail.content || mail.snippet || ''"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      title="邮件详情"
      size="720px"
      :visible.sync="mailShow"
      append-to-body
    >
      <div
        class="px-4 pb-4"
        v-loading="mailLoading"
      >
        <el-descriptions
          :column="1"
          border
          size="medium"
        >
          <el-descriptions-item label="收件邮箱">{{ mailPreview.googleEmail || '--' }}</el-descriptions-item>
          <el-descriptions-item label="发件人">{{ mailPreview.fromAddress || '--' }}</el-descriptions-item>
          <el-descriptions-item label="主题">{{ mailPreview.subject || '--' }}</el-descriptions-item>
          <el-descriptions-item label="收件时间">{{ formatTime(mailPreview.receivedTime) }}</el-descriptions-item>
        </el-descriptions>
        <mail-body
          class="mt-3"
          :content="mailPreview.content || mailPreview.snippet || ''"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { adTablePage } from '@adCommonComponent';
import { getAlertAccountPage, getAlertAccountDetail, getAlertMailDetail, getGmailAuthUrl, getMailboxWatch, getMailFlowPage, getOrphanPage, seedDemo } from '@/api/google/mailMonitor';

// 邮件正文按转发信排版后再展示。
function decodeQuotedPrintable(input) {
  const text = input == null ? '' : String(input);
  if (!/=[0-9A-Fa-f]{2}/.test(text)) {
    return text;
  }
  const source = text.replace(/=\r?\n/g, '').replace(/= (?=[0-9A-Fa-f]{2})/g, '');
  const bytes = [];
  for (let i = 0; i < source.length; i += 1) {
    if (source[i] === '=' && /[0-9A-Fa-f]{2}/.test(source.slice(i + 1, i + 3))) {
      bytes.push(parseInt(source.slice(i + 1, i + 3), 16));
      i += 2;
    } else {
      const code = source.charCodeAt(i);
      if (code < 128) {
        bytes.push(code);
      } else {
        Array.from(new TextEncoder().encode(source[i])).forEach((b) => bytes.push(b));
      }
    }
  }
  try {
    return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
  } catch (e) {
    return text;
  }
}

function sanitizeEmailHtml(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script,iframe,object,embed,link,meta').forEach((node) => node.remove());
  doc.querySelectorAll('*').forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value || '';
      if (name.startsWith('on') || name === 'srcdoc') {
        el.removeAttribute(attr.name);
      }
      if ((name === 'href' || name === 'src') && /^\s*javascript:/i.test(value)) {
        el.removeAttribute(attr.name);
      }
    });
  });
  return doc.body.innerHTML;
}

function paragraphize(text) {
  if (!text) {
    return [];
  }
  return text
    .replace(/。\s*/g, '。\n')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);
}

function presentMail(raw) {
  let text = decodeQuotedPrintable(raw).replace(/\u200F|\u200E/g, '').trim();
  if (/<\s*(html|body|table|div|p)\b/i.test(text)) {
    return {
      intro: '',
      forward: null,
      html: sanitizeEmailHtml(text),
      paragraphs: [],
    };
  }
  text = text
    .replace(/\s*-{5,}\s*Forwarded message\s*-{5,}/gi, '\n-----FORWARDED-----\n')
    .replace(/\s*-{5,}\s*转发的邮件\s*-{5,}/g, '\n-----FORWARDED-----\n');
  const parts = text.split('-----FORWARDED-----');
  const intro = (parts[0] || '').trim();
  const forward = parts.length > 1 ? parseForward(breakFirstHeaders(parts.slice(1).join('\n'))) : null;
  return {
    intro: forward ? intro : '',
    forward,
    html: '',
    paragraphs: paragraphize(forward ? forward.body : text),
  };
}

function breakFirstHeaders(block) {
  let rest = block;
  ['发件人', 'From', '日期', 'Date', '主题', 'Subject', '收件人', 'To', '抄送', 'Cc'].forEach((label) => {
    rest = rest.replace(new RegExp(`\\s+(${label})\\s*[:：]`, 'i'), `\n${label}: `);
  });
  return rest;
}

function peelAddress(value) {
  const matched = value.match(/^(.*?)(<?[^\s<>]+@[^\s<>]+>?)([\s\S]*)$/);
  if (!matched) {
    return { value: '', rest: value.trim() };
  }
  return {
    value: `${matched[1]}${matched[2]}`.trim(),
    rest: matched[3].trim(),
  };
}

function peelDate(value) {
  const rfc = /^([A-Za-z]{3},\s.+?(?:GMT|UTC|[+-]\d{4}))\s+([\s\S]+)$/;
  const numeric = /^(\d{4}[-/]\d{1,2}[-/]\d{1,2}(?:[ T]\d{1,2}:\d{2}(?::\d{2})?)?)\s+([\s\S]+)$/;
  const matched = value.match(rfc) || value.match(numeric);
  if (!matched) {
    return { value: value.trim(), rest: '' };
  }
  return { value: matched[1].trim(), rest: matched[2].trim() };
}

function peelSubject(value) {
  const matched = value.match(/^(.{8,120}?)\s+(您的|尊敬的|客户 ID[:：]|Hello\b|Hi\b)([\s\S]*)$/);
  if (!matched) {
    return { value: value.trim(), rest: '' };
  }
  return { value: matched[1].trim(), rest: `${matched[2]}${matched[3]}`.trim() };
}

function parseForward(block) {
  const forward = {
    from: '',
    date: '',
    subject: '',
    to: '',
    body: '',
  };
  const body = [];
  let inBody = false;
  block.split('\n').forEach((line) => {
    const row = line.trim();
    if (!row) {
      return;
    }
    if (inBody) {
      body.push(row);
      return;
    }
    const matched = row.match(/^(发件人|From|日期|Date|主题|Subject|收件人|To|抄送|Cc)\s*[:：]\s*(.*)$/i);
    if (!matched) {
      inBody = true;
      body.push(row);
      return;
    }
    const key = matched[1].toLowerCase();
    const raw = (matched[2] || '').trim();
    let peeled = { value: raw, rest: '' };
    if (key === 'from' || key === '发件人' || key === 'to' || key === '收件人' || key === 'cc' || key === '抄送') {
      peeled = peelAddress(raw);
    } else if (key === 'date' || key === '日期') {
      peeled = peelDate(raw);
    } else if (key === 'subject' || key === '主题') {
      peeled = peelSubject(raw);
    }
    if (key === 'from' || key === '发件人') {
      forward.from = peeled.value;
    } else if (key === 'date' || key === '日期') {
      forward.date = peeled.value;
    } else if (key === 'subject' || key === '主题') {
      forward.subject = peeled.value;
    } else if (key === 'to' || key === '收件人') {
      forward.to = peeled.value;
    }
    if (peeled.rest) {
      body.push(peeled.rest);
      inBody = true;
    }
  });
  forward.body = body.join('\n');
  return forward;
}

const MailBody = {
  name: 'MailBody',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  render(h) {
    const view = presentMail(this.content);
    const nodes = [];
    if (view.intro) {
      nodes.push(h('p', { class: 'mail-intro' }, view.intro));
    }
    if (view.forward) {
      const lines = [h('div', { class: 'mail-forward-title' }, '转发的邮件')];
      [
        ['发件人', view.forward.from],
        ['日期', view.forward.date],
        ['主题', view.forward.subject],
        ['收件人', view.forward.to],
      ].forEach(([label, value]) => {
        if (value) {
          lines.push(h('div', { class: 'mail-line' }, [h('span', label), h('b', value)]));
        }
      });
      nodes.push(h('div', { class: 'mail-forward' }, lines));
    }
    if (view.html) {
      nodes.push(h('div', { class: 'mail-html', domProps: { innerHTML: view.html } }));
    } else {
      nodes.push(h('div', { class: 'mail-prose' }, view.paragraphs.map((paragraph) => h('p', paragraph))));
    }
    return h('div', { class: 'mail-sheet' }, nodes);
  },
};

const EVENT_TYPE_OPTIONS = [
  { name: '广告账户超时未验证', id: 'ACCOUNT_VERIFICATION_TIMEOUT' },
  { name: '未付款项暂停', id: 'UNPAID_SUSPENSION' },
  { name: '付款可疑行为', id: 'SUSPICIOUS_BEHAVIOR' },
  { name: '账户被中止', id: 'ACCOUNT_ABORTED' },
  { name: '申诉失败', id: 'APPEAL_FAILURE' },
  { name: '账户验证警告', id: 'ACCOUNT_VERIFICATION_WARNING' },
  { name: '账户被撤销', id: 'ACCOUNT_REVOKED' },
  { name: '违规提醒', id: 'POLICY_VIOLATION_REMINDER' },
  { name: '其他', id: 'OTHER' },
];

export default {
  components: {
    adTablePage,
    MailBody,
  },
  data() {
    return {
      formData: {
        status: 'OPEN',
      },
      mailboxWatch: [],
      mailRows: [],
      orphanRows: [],
      orphanTotal: 0,
      mailShow: false,
      mailLoading: false,
      mailPreview: {},
      accountTotal: 0,
      tab: 'account',
      detailShow: false,
      detailLoading: false,
      detail: {},
      filedList: {
        status: {
          label: '',
          key: 'status',
          type: 'select',
          placeholder: '异常状态',
          options: [
            { name: '仅当前异常', id: 'OPEN' },
            { name: '全部（含已恢复）', id: 'ALL' },
          ],
        },
        customerId: {
          label: '',
          key: 'customerId',
          type: 'input',
          placeholder: '客户 ID',
        },
        accountName: {
          label: '',
          key: 'accountName',
          type: 'input',
          placeholder: '账户名称',
        },
        eventType: {
          label: '',
          key: 'eventType',
          type: 'select',
          placeholder: '事件类型',
          options: EVENT_TYPE_OPTIONS,
        },
        btn: {
          type: 'btn',
        },
      },
      tableConfig: {
        api: getAlertAccountPage,
        rowKey: 'customerId',
        columns: [
          {
            label: '广告账户',
            prop: 'account',
            width: '260px',
          },
          {
            label: '当前异常',
            prop: 'eventType',
            width: '160px',
          },
          {
            label: '原因',
            prop: 'reason',
            minWidth: '280px',
          },
          {
            label: '发生时间',
            prop: 'occurredAt',
            width: '180px',
          },
          {
            label: '证据',
            prop: 'evidenceCount',
            width: '90px',
          },
        ],
        operation: {
          width: 120,
          columns: [
            {
              type: 'text',
              text: '查看详情',
              click: (row) => this.viewDetail(row),
            },
          ],
        },
        showPage: true,
        refresh: true,
        showSelectBox: false,
        formatterParams(params) {
          const { order, pageNum, prop, page_length, ...data } = params;
          return {
            page: pageNum,
            pageSize: page_length || params.pageSize || 20,
            status: data.status || 'OPEN',
            ...data,
          };
        },
        formatterTableData: (res) => {
          const page = res.data || {};
          this.accountTotal = page.total || 0;
          return {
            list: page.list || [],
            total: page.total || 0,
          };
        },
      },
    };
  },
  computed: {
    drawerTitle() {
      const name = this.detail.accountName || '账户异常';
      const cid = this.detail.customerIdDisplay || this.detail.customerId || '';
      return cid ? `${name}（${cid}）` : name;
    },
  },
  methods: {
    eventTypeText(type) {
      const item = EVENT_TYPE_OPTIONS.find((v) => v.id === type);
      return item ? item.name : type || '--';
    },
    eventTagType(type) {
      if (
        [
          'ACCOUNT_ABORTED',
          'ACCOUNT_REVOKED',
          'UNPAID_SUSPENSION',
          'ACCOUNT_VERIFICATION_TIMEOUT',
          'APPEAL_FAILURE',
        ].includes(type)
      ) {
        return 'danger';
      }
      if (['ACCOUNT_VERIFICATION_WARNING', 'POLICY_VIOLATION_REMINDER', 'SUSPICIOUS_BEHAVIOR'].includes(type)) {
        return 'warning';
      }
      return 'info';
    },
    formatTime(v) {
      if (!v) return '--';
      return String(v).replace('T', ' ').slice(0, 19);
    },
    authStatusText(status) {
      if (status === 'VALID') return '有效';
      if (status === 'INVALID') return '已失效';
      if (status === 'EXPIRED') return '已过期';
      return '未授权';
    },
    watchStatusText(row) {
      if (row.watching) return '监听中';
      if (row.authStatus === 'INVALID') return '已失效';
      return '未监听';
    },
    authMailbox() {
      getGmailAuthUrl().then((res) => {
        if (res.code == 0) {
          window.open(res.data);
        }
      });
    },
    refreshPage() {
      this.loadMailboxWatch();
      this.loadOrphans();
      if (this.tab === 'mail') {
        this.loadMailFlow();
      }
      this.tableConfig.refresh = !this.tableConfig.refresh;
    },
    loadMailboxWatch() {
      return getMailboxWatch().then((res) => {
        this.mailboxWatch = res.code == 0 && Array.isArray(res.data) ? res.data : [];
      });
    },
    switchTab(name) {
      this.tab = name;
      if (name === 'mail') {
        this.loadMailFlow();
      }
      if (name === 'orphan') {
        this.loadOrphans();
      }
    },
    loadMailFlow() {
      getMailFlowPage({ page: 1, pageSize: 50 }).then((res) => {
        const page = res.code == 0 && res.data ? res.data : {};
        this.mailRows = page.list || [];
      });
    },
    loadOrphans() {
      return getOrphanPage({ page: 1, pageSize: 50 }).then((res) => {
        const page = res.code == 0 && res.data ? res.data : {};
        this.orphanRows = page.list || [];
        this.orphanTotal = page.total || 0;
      });
    },
    viewOrphan(row) {
      this.mailShow = true;
      this.mailLoading = true;
      this.mailPreview = { ...row };
      getAlertMailDetail({ mailId: row.mailId })
        .then((res) => {
          if (res.code == 0 && res.data) {
            this.mailPreview = res.data;
          }
        })
        .finally(() => {
          this.mailLoading = false;
        });
    },
    viewDetail(row) {
      this.detailShow = true;
      this.detailLoading = true;
      this.detail = {
        customerId: row.customerId,
        customerIdDisplay: row.customerIdDisplay,
        accountName: row.accountName,
        timeline: [],
      };
      getAlertAccountDetail({ customerId: row.customerId })
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.detail = res.data;
          } else {
            this.$message.error(res.comment || '加载详情失败');
          }
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
  },
  mounted() {
    seedDemo()
      .catch(() => null)
      .finally(() => {
        this.loadMailboxWatch();
        this.loadMailFlow();
        this.loadOrphans();
        this.tableConfig.refresh = !this.tableConfig.refresh;
      });
    this.onPageShow = () => {
      if (document.visibilityState === 'visible') {
        this.refreshPage();
      }
    };
    document.addEventListener('visibilitychange', this.onPageShow);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onPageShow);
  },
};
</script>
<style lang="scss" scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebeef5;
}
.page-title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}
.page-desc {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}
.tabs {
  display: flex;
  gap: 24px;
  padding: 0 16px;
  border-bottom: 1px solid #ebeef5;
}
.tab {
  padding: 12px 0;
  color: #606266;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}
.tab.active {
  color: #409eff;
  font-weight: 500;
  border-bottom-color: #409eff;
}
.badge {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  background: #f56c6c;
  border-radius: 9px;
}
.badge.gray {
  background: #c0c4cc;
}
.panel {
  padding: 0 0 12px;
}
.note {
  margin: 12px 16px;
  padding: 8px 12px;
  color: #606266;
  font-size: 12px;
  background: #f4f4f5;
  border-left: 3px solid #909399;
  border-radius: 2px;
}
::v-deep .el-table__body-wrapper {
  height: calc(100vh - 360px);
  overflow-y: auto;
  overflow-x: hidden;
}

.timeline {
  position: relative;
  padding-left: 18px;
}
.timeline::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: #ebeef5;
}
.tl-item {
  position: relative;
  padding-bottom: 18px;
}
.tl-item::before {
  content: '';
  position: absolute;
  left: -18px;
  top: 5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #c0c4cc;
  border: 2px solid #fff;
}
.tl-item.red::before {
  background: #f56c6c;
}
.tl-item.green::before {
  background: #67c23a;
}
.evi {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
.evi-head {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background: #fafafa;
  font-size: 12px;
  color: #606266;
}
.evi-body {
  padding: 10px 12px;
  font-size: 13px;
}
::v-deep .mail-sheet {
  max-height: 420px;
  overflow: auto;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.7;
  color: #303133;
}
::v-deep .mail-intro {
  margin: 0 0 10px;
}
::v-deep .mail-forward {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}
::v-deep .mail-forward-title {
  margin-bottom: 6px;
  color: #909399;
  font-size: 12px;
}
::v-deep .mail-line {
  display: flex;
  gap: 8px;
  margin-top: 2px;
}
::v-deep .mail-line span {
  flex: none;
  width: 56px;
  color: #909399;
}
::v-deep .mail-line b {
  font-weight: 500;
  word-break: break-word;
}
::v-deep .mail-prose p {
  margin: 0 0 8px;
}
::v-deep .mail-html {
  word-break: break-word;
}
::v-deep .mail-html img {
  max-width: 100%;
}
</style>
